import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {
    waitForElm('.rbox-widget.rendered .rbox-jobs-group .rbox-opening-li').then(() => {

        $(".rbox-widget.rendered").wrap("<div class='jobs-content-wrap'></div>");

        initializeLocationsFilter();
        initializePositionsFilter();
        const locationsFilter = displayLocationsFilter();
        const positionFilter = displayPositionsFilter();
        const testFilter = displayTestFilter();
        dropdownFunctionality();
        clearFunctionality();
        rednerNoResults();

        $("#jobs-filter-reset").on("click", function () {
            resetFunctionality(locationsFilter);
            resetFunctionality(positionFilter);
            resetFunctionality(testFilter);
        });

        /*  zapri dropdown, če ne klikneš na filtre  */
        $("body").click(function (event) {
            let container = $(".filter-input");

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(event.target) && container.has(event.target).length === 0) {
                $(".filter-title").each(function () {
                    let filterData = $(this).attr("filter-data");
                    populateMainLabel(filterData, "close");
                });
            }
        });
    });
});

$(window).on('hashchange', function () {
    const hash = window.location.hash;
    if (hash === '#openings-list') {
        waitForElm('.rbox-widget.rendered .rbox-jobs-group .rbox-opening-li').then(() => {
            initializeLocationsFilter();
            initializePositionsFilter();

            $(".filter-title").each(function () {
                let filterData = $(this).attr("filter-data");
                resetFunctionality(filterData);
            });
        });
    }
});

function resetFunctionality(filterData) {
    $(".checkbox-input[filter-data=" + filterData + "]").prop('checked', false);
    populateMainLabel(filterData);

    let filterTitle = $(".filter-title[filter-data=" + filterData + "]");
    let filterContent = $(".filter-content[filter-data=" + filterData + "]");

    filterTitle.removeClass("active");
    filterContent.hide();

    initializeLocationsFilter();
    initializePositionsFilter();

}

function generateRandomId() {
    return Math.random().toString(36).substr(2, 8);
}

function clearFunctionality() {
    $(".filter-clear").each(function () {
        $(this).on("click", function () {
            let filterData = $(this).attr("filter-data");
            $(".checkbox-input[filter-data=" + filterData + "]").prop('checked', false);

            if ($(this).hasClass("location")) {
                $(".rbox-jobs-group").each(function () {
                    $(this).addClass("default-state");
                    $(this).removeClass("displayed");
                    hideEmptyResults();
                });
            }
            if ($(this).hasClass("position")) {
                $(".rbox-opening-li").each(function () {
                    $(this).removeClass("displayed");
                    $(this).removeClass("default-state");
                    $(this).addClass("default-state");
                    handleCheckboxChange();

                });
            }
            if ($(this).hasClass("test")) {
                $(".rbox-opening-li").each(function () {
                    $(this).removeClass("displayed");
                    $(this).removeClass("default-state");
                    $(this).addClass("default-state");
                    handleCheckboxChange();

                });
            }
        });
    });
}

function populateMainLabel(filterData, $action) {

    let filterContent = $(".filter-content[filter-data=" + filterData + "]");
    let filterTitle = $(".filter-title[filter-data=" + filterData + "]");
    let checkboxInput = $(".checkbox-input[filter-data=" + filterData + "]");

    if ($action === "close") {
        filterContent.slideUp();
        filterTitle.removeClass("active");
    } else {
        filterContent.slideToggle();
        filterTitle.toggleClass("active");
    }

    const selectedLabels = [];
    checkboxInput.each(function () {
        if ($(this).is(':checked')) {
            const label = $(this).next('label').text();
            selectedLabels.push(label);
        }
    });
    const labelsJoined = selectedLabels.join(", ");

    if (labelsJoined) {
        filterTitle.addClass("selected");
        filterTitle.text(labelsJoined.slice(0, 28).replace(/,$/, '') + (labelsJoined.length > 28 ? '...' : ''));
    } else {
        filterTitle.removeClass("selected");
        const dataJson = JSON.parse(atob($("#data-json").attr("data-json")));
        if (filterTitle.hasClass("location")) {
            filterTitle.text(dataJson.translations.location);
        }
        if (filterTitle.hasClass("position")) {
            filterTitle.text(dataJson.translations.position);
        }
        if (filterTitle.hasClass("test")) {
            filterTitle.text(dataJson.translations.test);
        }
    }
}

function initializeLocationsFilter() {
    $(".rbox-jobs-group").each(function () {
        $(this).addClass("default-state");
    });
}

function initializePositionsFilter() {
    $(".rbox-opening-li").each(function () {
        $(this).addClass("default-state");
    });
}

function dropdownFunctionality() {
    $(".filter-title, .filter-close").each(function () {
        $(this).on("click", function () {
            let filterData = $(this).attr("filter-data");
            populateMainLabel(filterData);
        });
    });
}

function sanitizeString(dirtyString) {
    return dirtyString.replace(/[^A-Za-z]/g, "").toLowerCase();
}

function displayLocationsFilter() {

    const filterID = generateRandomId();
    const dataJson = JSON.parse(atob($("#data-json").attr("data-json")));

    let html = "";
    html += "<div filter-data='" + filterID + "' class='filter-input location'>";
    html += "<p filter-data='" + filterID + "' class='filter-title location'>" + dataJson.translations.location + "</p>";
    html += "<div filter-data='" + filterID + "' class='filter-content location'>";
    html += "<p filter-data='" + filterID + "' class='filter-clear location'>" + dataJson.translations.clear + "</p>";
    $(".rbox-jobs-group h3").each(function () {
        let locationTitle = $(this).text();
        let numberOfOpenSpots = $(this).siblings(".rbox-opening-li").length;

        html += "<div filter-data='" + filterID + "' class='checkbox'>";
        html += "<input filter-data='" + filterID + "' class='checkbox-input' type='checkbox' id='" + sanitizeString(locationTitle) + "'>";
        html += "<label filter-data='" + filterID + "' class='checkbox-title'>" + locationTitle;
        html += "</label>";
        html += "<span filter-data='" + filterID + "' class='checkbox-count " + sanitizeString(locationTitle) + "'> " + numberOfOpenSpots;
        html += "</span>";
        html += "</div>";
    });
    html += "<p filter-data='" + filterID + "' class='filter-close location'>" + dataJson.translations.close + "</p>";
    html += "</div>";
    html += "</div>";
    $("#jobs-filter").append("<div id='jobs-filter-location'></div>");
    $("#jobs-filter-location").append(html);
    $("#jobs-filter-location .checkbox-input:checkbox").on("change", handleCheckboxChangeLocation);

    return filterID;

}

/*function recountLocationElements(statusClass) {
    $(".rbox-jobs-group h3").each(function () {
        let numberOfOpenSpots = $(this).siblings(".rbox-opening-li." + statusClass).length;
        $(".checkbox-count." + sanitizeString($(this).text())).text(numberOfOpenSpots);
    });
}*/

/*function recountPositionElements(statusClass) {
}*/

function handleCheckboxChangeLocation() {

    let selector = $("#jobs-filter-location .checkbox-input:checked");
    let arrLocation = [];

    selector.each(function () {
        arrLocation.push($(this).next().text());
    });


    $(".rbox-jobs-group").each(function () {
        if (arrLocation.includes($(this).children("h3").text())) {
            $(this).addClass("displayed");
        }
    });

    //
    // $(".rbox-jobs-group").each(function () {
    //     $(this).removeClass("default-state");
    // });
    //
    // if ($(this).is(":checked")) {
    //     $(".jobs-content-wrap *").filter(function () {
    //         return $(this).text() === selector;
    //     }).parent().addClass("displayed");
    // } else {
    //     $(".jobs-content-wrap *").filter(function () {
    //         return $(this).text() === selector;
    //     }).parent().removeClass("displayed");
    // }

    //checkCheckboxes($("#jobs-filter-location .checkbox-input"), initializeLocationsFilter, recountPositionElements);
    hideEmptyResults();
}

function displayPositionsFilter() {

    const filterID = generateRandomId();
    const dataJson = JSON.parse(atob($("#data-json").attr("data-json")));

    let html = "";
    html += "<div filter-data='" + filterID + "' class='filter-input position'>";
    html += "<p filter-data='" + filterID + "' class='filter-title position'>" + dataJson.translations.position + "</p>";
    html += "<div filter-data='" + filterID + "' class='filter-content position'>";
    html += "<p filter-data='" + filterID + "' class='filter-clear position'>" + dataJson.translations.clear + "</p>";

    dataJson.positions.forEach(function (position) {

        let values = position.filter.split("-");
        let check = false;

        values.forEach(function (searchText) {

            let titles = $(".rbox-opening-li-title");
            titles.each(function () {
                if ($(this).text().match(new RegExp(searchText, "i"))) {
                    check = true;
                }
            });
        });

        if (check === true) {
            html += "<div filter-data='" + filterID + "' class='checkbox'>";
            html += "<input filter-data='" + filterID + "' class='checkbox-input' type='checkbox' id='Expert'>";
            html += "<label filter-data='" + filterID + "' class='checkbox-title' data='" + position.filter + "'>" + position.label;
            html += "</label>";
            html += "<span filter-data='" + filterID + "' class='checkbox-count'>";
            html += "</span>";
            html += "</div>";
        }
    });

    html += "<p filter-data='" + filterID + "' class='filter-close position'>" + dataJson.translations.close + "</p>";
    html += "</div>";
    html += "</div>";

    $("#jobs-filter").append("<div class='multiple' id='jobs-filter-position'></div>");
    $("#jobs-filter-position").append(html);
    $("#jobs-filter-position .checkbox-input:checkbox").on("change", handleCheckboxChange);

    return filterID;

}

function displayTestFilter() {

    const filterID = generateRandomId();
    const dataJson = JSON.parse(atob($("#data-json").attr("data-json")));

    let html = "";
    html += "<div filter-data='" + filterID + "' class='filter-input test'>";
    html += "<p filter-data='" + filterID + "' class='filter-title test'>" + dataJson.translations.test + "</p>";
    html += "<div filter-data='" + filterID + "' class='filter-content test'>";
    html += "<p filter-data='" + filterID + "' class='filter-clear test'>" + dataJson.translations.clear + "</p>";

    dataJson.positions.forEach(function (test) {

        let values = test.filter.split("-");
        let check = false;

        values.forEach(function (searchText) {
            let titles = $(".rbox-opening-li-title");
            titles.each(function () {
                if ($(this).text().match(new RegExp(searchText, "i"))) {
                    check = true;
                }
            });
        });

        if (check === true) {
            html += "<div filter-data='" + filterID + "' class='checkbox'>";
            html += "<input filter-data='" + filterID + "' class='checkbox-input' type='checkbox' id='Expert'>";
            html += "<label filter-data='" + filterID + "' class='checkbox-title' data='" + test.filter + "'>" + test.label;
            html += "</label>";
            html += "<span filter-data='" + filterID + "' class='checkbox-count'>";
            html += "</span>";
            html += "</div>";
        }

    });

    html += "<p filter-data='" + filterID + "' class='filter-close test'>" + dataJson.translations.close + "</p>";
    html += "</div>";
    html += "</div>";

    $("#jobs-filter").append("<div class='multiple' id='jobs-filter-test'></div>");
    $("#jobs-filter-test").append(html);
    $("#jobs-filter-test .checkbox-input").on("change", handleCheckboxChange);

    return filterID;

}

function handleCheckboxChange() {

    let arrTest = [];
    let arrPosition = [];
    let selector;

    let checkedInputsTest = $('#jobs-filter-test input:checked');
    let checkedInputsPos = $('#jobs-filter-position input:checked');

    checkedInputsTest.each(function () {
        selector = $(this).siblings(".checkbox-title").attr("data").split("-");
        for (let i = 0; i < selector.length; i++) {
            let testString = selector[i];
            arrTest.push(testString);
        }
    });

    checkedInputsPos.each(function () {
        selector = $(this).siblings(".checkbox-title").attr("data").split("-");
        for (let i = 0; i < selector.length; i++) {
            let testString = selector[i];
            arrPosition.push(testString);
        }
    });

    let elements = $(".rbox-opening-li");
    elements.each(function () {

        let isAnyCheckboxCheckedTest = false;
        let isAnyCheckboxCheckedPosition = false;
        for (let i = 0; i < $("#jobs-filter-test .checkbox-input").length; i++) {
            if ($("#jobs-filter-test .checkbox-input")[i].checked) {
                isAnyCheckboxCheckedTest = true;
                break;
            }
        }

        for (let i = 0; i < $("#jobs-filter-position .checkbox-input").length; i++) {
            if ($("#jobs-filter-position .checkbox-input")[i].checked) {
                isAnyCheckboxCheckedPosition = true;
                break;
            }
        }

        $(this).removeClass("displayed");
        $(this).removeClass("default-state");

        let element = $(this);
        let text = element.text();
        let testChecker = false;
        let positionChecker = false;

        for (let i = 0; i < arrTest.length; i++) {
            let testString = arrTest[i];

            if (text.match(new RegExp(testString, "i"))) {
                testChecker = true
                break;
            }
        }

        for (let i = 0; i < arrPosition.length; i++) {
            let testString = arrPosition[i];

            if (text.match(new RegExp(testString, "i"))) {
                positionChecker = true
                break;
            }
        }

        if (isAnyCheckboxCheckedTest && isAnyCheckboxCheckedPosition) {
            if (testChecker && positionChecker) {
                element.addClass("displayed");
            }
        } else {
            if (isAnyCheckboxCheckedPosition && positionChecker) {
                element.addClass("displayed");
            }
            if (isAnyCheckboxCheckedTest && testChecker) {
                element.addClass("displayed");
            }
        }


    });

    //checkCheckboxes($(".multiple .checkbox-input"), initializePositionsFilter, recountLocationElements);
    hideEmptyResults();

}

/*function checkCheckboxes(checkboxes, callback, recount) {
    // let isAnyCheckboxChecked = false;
    // for (let i = 0; i < checkboxes.length; i++) {
    //     if (checkboxes[i].checked) {
    //         isAnyCheckboxChecked = true;
    //         break;
    //     }
    // }
    //
    // console.log(isAnyCheckboxChecked);
    //
    // if (!isAnyCheckboxChecked) {
    //     callback();
    //     recount("default-state");
    // } else {
    //     recount("displayed");
    // }
}*/

function hideEmptyResults() {

    $(".rbox-jobs-group").each(function () {
        var group = $(this);
        var hasDisplayedChild = false;

        group.find("*").each(function () {
            if ($(this).hasClass("displayed")) {
                hasDisplayedChild = true;
                return false; // Exit the inner loop since we found a match
            }
        });

        if (!hasDisplayedChild) {
            group.removeClass("default-state");
            group.removeClass("displayed");
        } else {
            group.addClass("default-state");
        }
    });


    let isAnyChecked = true;

    for (let i = 0; i < $(".checkbox-input").length; i++) {
        if ($(".checkbox-input")[i].checked) {
            isAnyChecked = false;
            break;
        }
    }

    if (isAnyChecked) {

        $(".rbox-jobs-group").each(function () {
            $(this).removeClass("displayed");
            $(this).addClass("default-state");
        });
        $(".rbox-opening-li").each(function () {
            $(this).removeClass("displayed");
            $(this).addClass("default-state");
        });
    } else {
        let isAnyCheckboxCheckedTest = true;
        let isAnyCheckboxCheckedPosition = true;
        for (let i = 0; i < $("#jobs-filter-test .checkbox-input").length; i++) {
            if ($("#jobs-filter-test .checkbox-input")[i].checked) {
                isAnyCheckboxCheckedTest = false;
                break;
            }
        }

        for (let i = 0; i < $("#jobs-filter-position .checkbox-input").length; i++) {
            if ($("#jobs-filter-position .checkbox-input")[i].checked) {
                isAnyCheckboxCheckedPosition = false;
                break;
            }
        }

        if (isAnyCheckboxCheckedPosition && isAnyCheckboxCheckedTest) {
            $(".rbox-opening-li").each(function () {
                $(this).removeClass("displayed");
                $(this).addClass("default-state");
            });
        }
    }

    // - - -

    let isAnyCheckboxCheckedLocation = false;
    for (let i = 0; i < $("#jobs-filter-location .checkbox-input").length; i++) {
        if ($("#jobs-filter-location .checkbox-input")[i].checked) {
            isAnyCheckboxCheckedLocation = true;
            break;
        }
    }

    if (isAnyCheckboxCheckedLocation) {
        let tt = $("#jobs-filter-location .checkbox-input:checked");
        let arrLocation = [];

        tt.each(function () {
            arrLocation.push($(this).next().text());
        });

        $(".rbox-jobs-group").each(function () {

            if ($(this).hasClass('displayed') || $(this).hasClass('default-state')) {
                hasDisplayedOrDefaultStateClass = true;
            }

            if (arrLocation.includes($(this).children("h3").text())) {
                if ($(this).find(".displayed").length > 0 || $(this).find(".default-state").length > 0) {
                    $(this).addClass("displayed");
                }
            } else {
                $(this).removeClass("displayed");
                $(this).removeClass("default-state");
            }
        });

        if (hasDisplayedOrDefaultStateClass) {
            $("no-results").removeClass("hidden");
        } else {
            $("no-results").addClass("hidden");
        }

    }

    let hasDisplayedOrDefaultStateClass = false;

    $(".rbox-jobs-group").each(function () {
        if ($(this).hasClass('displayed') || $(this).hasClass('default-state')) {
            hasDisplayedOrDefaultStateClass = true;
        }
    });

    if (hasDisplayedOrDefaultStateClass) {
        $(".no-results").addClass("hidden");
    } else {
        $(".no-results").removeClass("hidden");
    }


}

function rednerNoResults() {

    if (!$('.jobs-content-wrap .no-results').length) {
        $('.jobs-content-wrap').after('<div class="no-results hidden">Leider gibt es zu dieser Auswahl keine offenen Stellen.</div>')
    }

}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}